const baseBagelIngredients = [
    "wheat flour",
    "water",
    "yeast",
    "salt",
    "malt",
    "sugar"
];

export const bagels = [
    {
        name: "everything",
        image: "/images/bagels/everything.png",
        description: "A savory bagel covered in a delightful mix of poppy seeds, sesame seeds, dried garlic, dried onion, and salt",
        ingredients: [
            ...baseBagelIngredients,
            "poppy seeds",
            "sesame seeds",
            "dried garlic",
            "dried onion",
            "coarse salt"
        ]
    },
    {
        name: "poppy",
        image: "/images/bagels/mohn.png",
        description: "Classic bagel generously coated with tiny, crunchy poppy seeds",
        ingredients: [
            ...baseBagelIngredients,
            "poppy seeds"
        ]
    },
    {
        name: "carrot",
        image: "/images/bagels/carrot.png",
        description: "Soft bagel infused with fresh carrots for a subtle sweetness and beautiful orange hue",
        ingredients: [
            ...baseBagelIngredients,
            "fresh carrots",
            "cinnamon",
            "nutmeg"
        ]
    },
    {
        name: "sesame",
        image: "/images/bagels/sesam.png",
        description: "Traditional bagel topped with toasted sesame seeds for a nutty flavor",
        ingredients: [
            ...baseBagelIngredients,
            "sesame seeds"
        ]
    },
    {
        name: "plain",
        image: "/images/bagels/plain.png",
        description: "Classic plain bagel with a chewy texture and golden-brown crust",
        ingredients: [
            ...baseBagelIngredients
        ]
    }
];